import bike1 from "../images/bike1.webp";
import bike2 from "../images/bike2.webp";
import bike3 from "../images/bike3.webp";
import cycle from "../images/cycle.webp";
import bike4 from "../images/bike4.webp";
import siri from "../images/siri_2020.webp";
import cosor from "../images/cosor1.webp";
import ranosonicCharger from "../images/ranosonicCharger.webp";
import camera2 from "../images/camera2.webp";
import camera3 from "../images/camera3.webp";
import camera4 from "../images/camera4.webp";

export const moreItem = [
  {
    id: 29,
    cardImg: bike1,
    title: "tarz t3",
    prizeCurrent: "164.70",
    prizeClose: " $183.00",
    off: "10%",
    like: false,
  },
  {
    id: 30,
    cardImg: bike2,
    title: "xamaha r15 black",
    prizeCurrent: "162.30",
    prizeClose: "$180.00",
    off: "10%",
    like: false,
  },
  {
    id: 31,
    cardImg: bike3,
    title: "xamaha r15 blue",
    prizeCurrent: "249.30",
    prizeClose: "$277.00",
    off: "10%",
    like: false,
  },
  {
    id: 32,
    cardImg: cycle,
    title: "xevel 2020",
    prizeCurrent: "256.50",
    prizeClose: "$270.00",
    off: "5%",
    like: false,
  },
  {
    id: 33,
    cardImg: bike4,
    title: "jakson tb1",
    prizeCurrent: "112.10",
    prizeClose: "$118.00",
    off: "5%",
    like: false,
  },
  {
    id: 34,
    cardImg: siri,
    title: "siri 2020",
    prizeCurrent: "122.20",
    prizeClose: "$130.00",
    off: "6%",
    like: false,
  },
  {
    id: 35,
    cardImg: cosor,
    title: "COSOR1",
    prizeCurrent: "273.60",
    prizeClose: "$288.00",
    off: "5%",
    like: false,
  },
  {
    id: 36,
    cardImg: ranosonicCharger,
    title: "ranasonic charger",
    prizeCurrent: "107.10",
    prizeClose: "$191.00",
    off: "10%",
    like: false,
  },
  {
    id: 37,
    cardImg: ranosonicCharger,
    title: "lumix DSIR",
    prizeCurrent: "115.32",
    prizeClose: "$124.00",
    off: "7%",
    like: false,
  },
  {
    id: 38,
    cardImg: camera2,
    title: "atech cam 1080p",
    prizeCurrent: "264.60",
    prizeClose: "$294.00",
    off: "10%",
    like: false,
  },
  {
    id: 39,
    cardImg: camera3,
    title: "tony a9",
    prizeCurrent: "233.70",
    prizeClose: "$246.00",
    off: "5%",
    like: false,
  },
  {
    id: 40,
    cardImg: camera4,
    title: "beat sw3",
    prizeCurrent: "112.53",
    prizeClose: "$121.00",
    off: "7%",
    like: false,
  },
];
